class Milkbox
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'milk-box--bound' && !@.$el.classList.contains 'milkbox--no-auto-binder'
            @.rotation = 0
            @.shown = false

            @.$el.classList.add 'milk-box--bound'
            @.Init()
        return
            
    
    Hide: ->
        @.$el.classList.remove 'milkbox--show-faces'
        @.shown = false
        return

    Init: ->
        @.Show()
        @.Rotate(30)
        return

    Rotate: (rotation) ->
        rotation = if rotation < 0 then 0 else if rotation > 45 then 45 else rotation
        @.$el.style.transform = 'rotateX(-16deg) rotateY(' + rotation + 'deg) rotateZ(0)'
        @.rotation = rotation
        return

    Show: ->
        @.$el.classList.add 'milkbox--show-faces'
        @.shown = true
        return

BindMilkboxes = ->
    document.querySelectorAll '.milkbox:not(.milk-box--bound):not(.milkbox--no-auto-binder)'
        .forEach (el) ->
            window.milkbox = new Milkbox (el)
            return
    return

window.addEventListener 'bind-components', BindMilkboxes